import { BookingsInsightsReport } from 'model/BookingsReport';
import { Action } from 'redux';

//Action Types
export const BOOKINGS_INSIGHTS_REPORT_GET_START = 'BOOKINGS_INSIGHTS_REPORT_GET_START';
export const BOOKINGS_INSIGHTS_REPORT_GET_SUCCESS = 'BOOKINGS_INSIGHTS_REPORT_GET_SUCCESS';
export const BOOKINGS_INSIGHTS_REPORT_GET_ERROR = 'BOOKINGS_INSIGHTS_REPORT_GET_ERROR';

//Actions
type BookingsInsightsReportGetStartAction = Action<typeof BOOKINGS_INSIGHTS_REPORT_GET_START>;

interface BookingsInsightsReportGetSuccessAction extends Action<typeof BOOKINGS_INSIGHTS_REPORT_GET_SUCCESS> {
    payload: {
        insights: BookingsInsightsReport;
    };
}

type BookingsInsightsReportErrorAction = Action<typeof BOOKINGS_INSIGHTS_REPORT_GET_ERROR>;

export type BookingsInsightsReportAction =
    | BookingsInsightsReportGetStartAction
    | BookingsInsightsReportGetSuccessAction
    | BookingsInsightsReportErrorAction;
